import React, {FunctionComponent} from "react";
import {TeamRegistration} from "/src/domain/challenges/ChallengeRegistrationData";
import {ChallengeUser} from "/src/domain/challenges/ChallengeUser";
import {Teams} from "/src/ui/challengesRegistration/teamRegistration/Teams";
import {CurrentTeam} from "/src/ui/challengesRegistration/teamRegistration/CurrentTeam";

export type AuthorizedTeamDetailsProps = {
    teamRegistration?: TeamRegistration;
    currentUser?: ChallengeUser;
    isRegActive: boolean;
}

export const AuthorizedTeamDetails: FunctionComponent<AuthorizedTeamDetailsProps> = ({
                                                                                         teamRegistration,
                                                                                         currentUser,
                                                                                         isRegActive
                                                                                     }) => {
    if (!teamRegistration || !currentUser) return null;

    return (
        <>
            {isRegActive && currentUser.challengeRegistration.isRegistered && <CurrentTeam
                teams={teamRegistration?.teams || []}
                isTeamCreator={Boolean(teamRegistration?.isTeamCreator)}
                teamKey={teamRegistration?.teamKey || ""}
                currentUser={currentUser}
            />}
            <Teams
                maxTeamParticipants={teamRegistration.maxTeamParticipants}
                teams={teamRegistration.teams}
                isRegistered={currentUser.challengeRegistration.isRegistered}
                isRegActive={isRegActive}
            />
        </>
    )

}